(() => {
  if (window.BAFFavourites) {
    window.BAFFavourites.refresh();
    return;
  }

  const storageKey = 'baf-art-prints-favourites-v1';
  let currentCount = 0;
  let feedbackTimer;

  function storedCount() {
    try {
      const items = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(items)) return 0;
      const keys = new Set();
      for (const item of items) {
        if (!item || !Number.isSafeInteger(item.id) || item.id <= 0 ||
            !['paper', 'canvas'].includes(item.material) ||
            typeof item.size !== 'string' || !/^\d+x\d+$/.test(item.size)) continue;
        const frame = ['oak', 'walnut'].includes(item.frame) ? 'wood' :
          ['black', 'white', 'wood', 'none'].includes(item.frame) ? item.frame : 'black';
        keys.add([item.id, item.material, item.size, frame].join('-'));
      }
      return keys.size;
    } catch {
      return 0;
    }
  }

  function render(count) {
    currentCount = count;
    for (const link of document.querySelectorAll('[data-baf-favourites-link]')) {
      link.classList.toggle('has-saved', count > 0);
      link.setAttribute('aria-label', 'Open your favourites, ' + count + ' saved configuration' + (count === 1 ? '' : 's'));
      const badge = link.querySelector('[data-baf-favourites-badge]');
      const label = link.querySelector('[data-baf-favourites-count]');
      if (badge) badge.hidden = count === 0;
      if (label) label.textContent = count > 99 ? '99+' : String(count);
    }
  }

  function refresh() { render(storedCount()); }
  window.BAFFavourites = { refresh };

  // Draw attention to the destination only after an intentional save, not a page refresh.
  document.addEventListener('baf:favourite-saved', () => {
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches) return;
    for (const link of document.querySelectorAll('[data-baf-favourites-link]')) {
      link.classList.remove('is-saving');
      void link.offsetWidth;
      link.classList.add('is-saving');
    }
    clearTimeout(feedbackTimer);
    feedbackTimer = setTimeout(() => {
      document.querySelectorAll('[data-baf-favourites-link]').forEach(link => link.classList.remove('is-saving'));
    }, 1250);
  });

  // Art Prints supplies its catalogue-validated count immediately after saving.
  document.addEventListener('baf:favourites-change', event => {
    const count = event.detail?.count;
    if (Number.isSafeInteger(count) && count >= 0) render(count);
  });
  window.addEventListener('storage', event => {
    if (event.key === storageKey || event.key === null) refresh();
  });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refresh();
  });
  document.addEventListener('shopify:section:load', () => render(currentCount));
  refresh();
  document.dispatchEvent(new CustomEvent('baf:favourites-ready'));
})();
